/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { Noise1D } from './InteractiveComponents';
export const metadata = {
  demo: Noise1D,
  title: 'Noise (1D)'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A simple 1-dimensional noise function is a little like `}<inlineCode parentName="p">{`Math.sin()`}</inlineCode>{` in that it takes a coordinate and returns a value between -1.0 and 1.0, but randomly perturbed.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
